<script lang="ts">
const defaultMessage = 'Something went wrong'
</script>
<script setup lang="ts">
const __MACROS_props = defineProps({
  error: null
})
import { toRefs as __MACROS_toRefs } from "vue";
import type { NuxtError } from '#app'

definePageMeta({
  layout: 'custom',
})

const { error } = __MACROS_toRefs(__MACROS_props)

const errorCodes: Record<number, string> = {
  404: 'Page not found',
} as const

if (process.dev) console.error(error.value)


const message =
  error.value.message ?? errorCodes[error.value.statusCode!] ?? defaultMessage

const state = ref<'error' | 'reloading'>('error')

const reload = async (): Promise<void> => {
  state.value = 'reloading'

  try {
    await clearError({ redirect: '/' })
  } catch (err) {
    console.error(err)
    state.value = 'error'
  }
}
</script>

<template>
  <NuxtLoadingIndicator
    color="repeating-linear-gradient(to right,var(--c-primary) 0%,var(--c-primary-active) 100%)"
  />
  <NuxtLayout>
    <div class="relative">
      <slot>
        <div class="container mx-auto px-4 py-10">
          There was an error 😱

          <h1>{{ message }}</h1>

          <button
            class="gap-2 text-center"
            :disabled="state === 'reloading'"
            @click="reload"
          >
            <span
              v-if="state === 'reloading'"
              class="preserve-3d block animate-spin"
            >
              <span class="block" />
            </span>
            {{ state === 'reloading' ? 'Reloading' : 'Reload' }}
          </button>
          <br />
          <NuxtLink to="/"> Navigate home </NuxtLink>
        </div>
      </slot>
    </div>
  </NuxtLayout>
</template>
